function IntroV2Controller(){
	this.className			= "IntroV2Controller";
	this.view				= false;
	this.glob				= ["/test/intro/v2**"];
	this.viewData			= {};
}
IntroV2Controller.inheritsFrom( PageController );

IntroV2Controller.prototype.on = function(onComplete){
	this.$html          	= $('html');
	this.$body				= $('body');
	this.$logo 				= this.$body.find('.js-slash-screen--logo');

	//this.mousemoveDelegate = jstage.addListener("mousemove", (e) => this.onMousemove);

	gsap.registerPlugin(ScrollTrigger);
	this.timeline = gsap.timeline();

	this.setupLogoAnimation();
	//this.setupLogoAnimation();

	return true;
}

IntroV2Controller.prototype.setupLogoAnimation = function() {
	const containerSelector = '.js-intro';
	const titleSelector     = '.js-intro--title';
	const imageSelector     = '.js-intro--image';

	this.animationGroups = [];
	this.logoAnimationTimeline = [];

	//--- DESIRE

	for(let i=1; i<=5; i++){
	this.logoAnimationTimeline.push({
		selector: `#desire .intro--header .intro__title:nth-of-type(${i})`,
		triggerStart: "top 90%",
		triggerEnd: "bottom 10%",
		showMarkers: false,
		scrub: 0.5,
		items: [{
			selector: `#desire .intro--header .intro__title:nth-of-type(${i})`,
			props: {
				'--font-weight': { start: 200, end: 700 },
				'--font-slant': { start: 0, end: -14 },
				'--font-serif': { start: 0, end: 1 },
			},
			duration: 1,
			delay: 0.07,
			ease: 'power2.inOut',
		}]
	});
	}

	this.logoAnimationTimeline.push({
		selector: '#desire .intro--copy .intro__main',
		triggerStart: "bottom 100%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#desire .intro--copy .intro__title`,
			start: { x: 0, y: -80 },
			end: { x: 0, y: 80 },
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#desire .intro--copy .intro__main',
		triggerStart: "bottom 100%",
		triggerEnd: "bottom 80%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#desire .intro--copy .intro__title`,
			props: {
				opacity: { start: 0, end: 1 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#desire .intro--copy .intro__main',
		triggerStart: "top 20%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#desire .intro--copy .intro__title`,
			props: {
				opacity: { start: 1, end: 0 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});

	//--- STUDIO

	for(let i=1; i<=5; i++){
	this.logoAnimationTimeline.push({
		selector: `#studio .intro--header .intro__title:nth-of-type(${i})`,
		triggerStart: "top 90%",
		triggerEnd: "bottom 10%",
		showMarkers: false,
		scrub: 0.5,
		items: [{
			selector: `#studio .intro--header .intro__title:nth-of-type(${i}) .js-title--top`,
			props: {
				'--font-weight': { start: 700, end: 450 },
				'--font-serif': { start: 1, end: .5 },
			},
			duration: 1,
			delay: 0,
			ease: 'power2.inOut',
		},
		{
			selector: `#studio .intro--header .intro__title:nth-of-type(${i}) .js-title--bottom`,
			props: {
				'--font-weight': { start: 200, end: 450 },
				'--font-serif': { start: 0, end: .5 },
			},
			duration: 1,
			delay: 0,
			ease: 'power2.inOut',
		}]
	});
	}

	this.logoAnimationTimeline.push({
		selector: '#studio .intro--copy .intro__main',
		triggerStart: "bottom 100%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#studio .intro--copy .intro__title`,
			start: { x: 0, y: -80 },
			end: { x: 0, y: 80 },
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#studio .intro--copy .intro__main',
		triggerStart: "bottom 100%",
		triggerEnd: "bottom 80%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#studio .intro--copy .intro__title`,
			props: {
				opacity: { start: 0, end: 1 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#studio .intro--copy .intro__main',
		triggerStart: "top 20%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#studio .intro--copy .intro__title`,
			props: {
				opacity: { start: 1, end: 0 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});

	//--- TECHNOLOGY

	for(let i=1; i<=5; i++){
	/*
	this.logoAnimationTimeline.push({
		selector: `#technology .intro--header .intro__title:nth-of-type(${i})`,
		triggerStart: "top 90%",
		triggerEnd: "bottom 0%",
		showMarkers: false,
		scrub: 0.5,
		items: [{
			selector: `#technology .intro--header .intro__title:nth-of-type(${i})`,
			props: {
				'--font-kerning': { start: '0.001em', end: '0.04em' },
				'--font-weight': { start: 700, end: 200 },
			},
			duration: 1,
			delay: 0,
			ease: 'power2.easeIn',
		}]
	});
	*/
	this.logoAnimationTimeline.push({
		selector: `#technology .intro--header .intro__title:nth-of-type(${i})`,
		triggerStart: "top 90%",
		triggerEnd: "bottom 10%",
		showMarkers: false,
		scrub: 0.5,
		items: [{
			selector: `#technology .intro--header .intro__title:nth-of-type(${i})`,
			props: {
				'--font-serif': { start: 1, end: 0 },
				'--font-kerning': { start: '0.001em', end: '0.055em' },
				'--font-weight': { start: 700, end: 200 },
			},
			duration: 1,
			delay: 0,
			ease: 'power2.inOut',
		}]
	});
	/*
	this.logoAnimationTimeline.push({
		selector: `#technology .intro--header .intro__title:nth-of-type(${i})`,
		triggerStart: "top 30%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0.5,
		items: [{
			selector: `#technology .intro--header .intro__title:nth-of-type(${i})`,
			props: {
				opacity: { start: 1, end: 0 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});*/
	}

	this.logoAnimationTimeline.push({
		selector: '#technology .intro--copy .intro__main',
		triggerStart: "bottom 100%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#technology .intro--copy .intro__title`,
			start: { x: 0, y: -80 },
			end: { x: 0, y: 80 },
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#technology .intro--copy .intro__main',
		triggerStart: "bottom 100%",
		triggerEnd: "bottom 80%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#technology .intro--copy .intro__title`,
			props: {
				opacity: { start: 0, end: 1 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#technology .intro--copy .intro__main',
		triggerStart: "top 20%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#technology .intro--copy .intro__title`,
			props: {
				opacity: { start: 1, end: 0 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});

	//--- RESULTS
/*
	this.logoAnimationTimeline.push({
		selector: `#results .intro--header .intro__title`,
		triggerStart: "top 100%",
		triggerEnd: "top 10%",
		showMarkers: false,
		scrub: 0.5,
		items: [{
			selector: `#results .intro--header .intro__title`,
			props: {
				'--font-size': { start: '10.5vw', end: '7vw' },
				'--font-weight': { start: 700, end: 200 },
				'--font-kerning': { start: '0em', end: '0.25em' },
			},
			duration: 1,
			delay: 0,
			ease: 'Power2.out',
		}]
	});
*/
	this.logoAnimationTimeline.forEach((animation) => {
		//console.log(animation, $(animation.selector).id);

		const animationGroup = new GsapController({
			containerSelector: animation.selector,
			items: animation?.items,
			triggerStart: animation?.triggerStart,
			triggerEnd: animation?.triggerEnd,
			showMarkers: animation?.showMarkers,
			scrub: animation?.scrub,
		});
		this.animationGroups.push(animationGroup);
	});
}
IntroV2Controller.prototype.updateAnimationGroups = function(imageIndex) {
	this.animationGroups[imageIndex].calculateContainerBaseDimensions();
}







/*
function IntroV2Controller(){
	this.className			= "IntroV2Controller";
	this.view				= false;
	this.glob				= ["/test/intro/v2**"];
	this.viewData			= {};
}
IntroV2Controller.inheritsFrom( PageController );

IntroV2Controller.prototype.on = function(onComplete){
	this.$html          	= $('html');
	this.$body				= $('body');
	this.$logo 				= this.$body.find('.js-slash-screen--logo');

	//this.mousemoveDelegate = jstage.addListener("mousemove", (e) => this.onMousemove);

	gsap.registerPlugin(ScrollTrigger);
	this.timeline = gsap.timeline();

	this.setupLogoAnimation();
	//this.setupLogoAnimation();

	return true;
}

IntroV2Controller.prototype.setupLogoAnimation = function() {
	const containerSelector = '.js-intro';
	const titleSelector     = '.js-intro--title';
	const imageSelector     = '.js-intro--image';

	this.animationGroups = [];

	this.logoAnimationTimeline = [];

	//--- DESIRE
	for(let i=1; i<=5; i++){
		this.logoAnimationTimeline.push({
			selector: `#desire .js-intro--title:nth-of-type(${i})`,
			triggerStart: "top 100%",
			triggerEnd: "bottom 0%",
			showMarkers: false,
			scrub: 0.5,
			items: [{
				selector: `#desire .js-intro--title:nth-of-type(${i})`,
				props: {
					'--font-weight': { start: 200, end: 700 },
					'--font-slant': { start: 0, end: -14 },
					'--font-serif': { start: 0, end: 1 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power2.inOut',
			}]
		});
	}

	//--- WORK
	this.logoAnimationTimeline.push({
		selector: '#work .intro__main',
		triggerStart: "bottom 100%",
		triggerEnd: "top 0%",
		showMarkers: true,
		scrub: 0,
		items: [{
			selector: `#work .js-intro--title`,
			start: { x: 0, y: -80 },
			end: { x: 0, y: 80 },
			duration: 1,
			delay: 0,//0.07,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#work .intro__main',
		triggerStart: "bottom 100%",
		triggerEnd: "bottom 80%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#work .js-intro--title`,
			props: {
				opacity: { start: 0, end: 1 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#work .intro__main',
		triggerStart: "top 20%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#work .js-intro--title`,
			props: {
				opacity: { start: 1, end: 0 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});

	//--- STUDIO
	for(let i=1; i<=5; i++){
		this.logoAnimationTimeline.push({
			selector: `#studio .js-intro--title:nth-of-type(${i})`,
			triggerStart: "top 100%",
			triggerEnd: "bottom 40%",
			showMarkers: false,
			scrub: 0.5,
			items: [{
				selector: `#studio .js-intro--title:nth-of-type(${i}) .js-title--top`,
				props: {
					'--font-weight': { start: 700, end: 450 },
					'--font-serif': { start: 1, end: .5 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'power4.inOut',
			},
			{
				selector: `#studio .js-intro--title:nth-of-type(${i}) .js-title--bottom`,
				props: {
					'--font-weight': { start: 200, end: 450 },
					'--font-serif': { start: 0, end: .5 },
				},
				duration: 1,
				delay: 0.07,
				ease: 'linear',
			}]
		});
	}

	//--- PORTFOLIO
	this.logoAnimationTimeline.push({
		selector: '#portfolio .intro__main',
		triggerStart: "bottom 100%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#portfolio .js-intro--title`,
			start: { x: 0, y: -80 },
			end: { x: 0, y: 80 },
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#portfolio .intro__main',
		triggerStart: "bottom 100%",
		triggerEnd: "bottom 80%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#portfolio .js-intro--title`,
			props: {
				opacity: { start: 0, end: 1 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});
	this.logoAnimationTimeline.push({
		selector: '#portfolio .intro__main',
		triggerStart: "top 20%",
		triggerEnd: "top 0%",
		showMarkers: false,
		scrub: 0,
		items: [{
			selector: `#portfolio .js-intro--title`,
			props: {
				opacity: { start: 1, end: 0 },
			},
			duration: 1,
			delay: 0,
			ease: 'linear',
		}]
	});

	//--- TECHNOLOGY
	for(let i=1; i<=5; i++){
		this.logoAnimationTimeline.push({
			selector: `#technology .js-intro--title:nth-of-type(${i})`,
			triggerStart: "top 100%",
			triggerEnd: "top 10%",
			showMarkers: false,
			scrub: 0.5,
			items: [{
				selector: `#technology .js-intro--title:nth-of-type(${i})`,
				props: {
					//'letter-spacing': { start: '0px', end: '-1px' },
					'--font-weight': { start: 700, end: 200 },
				},
				duration: 1,
				delay: 0,
				ease: 'Power2.out',
			}]
		});
		this.logoAnimationTimeline.push({
			selector: `#technology .js-intro--title:nth-of-type(${i})`,
			triggerStart: "top 30%",
			triggerEnd: "top 0%",
			showMarkers: true,
			scrub: 0.5,
			items: [{
				selector: `#technology .js-intro--title:nth-of-type(${i})`,
				props: {
					opacity: { start: 1, end: 0 },
				},
				duration: 1,
				delay: 0,
				ease: 'linear',
			}]
		});
	}

	this.logoAnimationTimeline.forEach((animation) => {
		console.log(animation, $(animation.selector).id);

		const animationGroup = new GsapController({
			containerSelector: animation.selector,
			items: animation?.items,
			triggerStart: animation?.triggerStart,
			triggerEnd: animation?.triggerEnd,
			showMarkers: animation?.showMarkers,
			scrub: animation?.scrub,
		});
		this.animationGroups.push(animationGroup);
	});
}
IntroV2Controller.prototype.updateAnimationGroups = function(imageIndex) {
	this.animationGroups[imageIndex].calculateContainerBaseDimensions();
}
*/